import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import Sort from "../../Assets/sort.svg";
import {Route, withRouter} from "react-router";
import Modal from "../../Container/Modal";
import Loader from "../../Container/Loader";


// style
import HomeStyle from "./style";

// -- redux
import {connect} from "react-redux";
import {GetQuestions, UpdateQuestionStatus, DeleteQuestion, ImportData} from "../../Redux/Actions/QuestionAction"

// img
import Pen from "../../Assets/pen.svg";
import DeleteIcon from "../../Assets/Delete.svg";
import FullSidebarQuestions from "../../Container/FullPageSidebar/questions";

function Questions(props) {
    const [response, setResponse] = useState(false);
    const [Name, setName] = useState(false);
    const [OpenModal, setModal] = useState(false);
    const [Id, setId] = useState(false);
    const [InitialArray, setInitialArray] = useState([]);
    const [questions, setQuestions] = useState([]);

    useEffect(() => {
        if(props.status === '') {
            props.GetQuestions('');
        } else {
            let data = {
                status: props.status
            };
            props.GetQuestions(data);
        }
    }, [props.status, props.update_data, props.delete_data, props.location.back, props.import_data, props.add_data, props.edit_data, props.delete_data]);

    useEffect(() => {
        setTimeout(function () {
            setResponse(true)
        }, 1000)
    }, []);

    useEffect(() => {
        props.clear('clear');
    },[props.location.clear]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            props.enabled(props.data.data.enabled);
            props.disabled(props.data.data.disabled);
            setInitialArray(props.data.data.data);
            setTimeout( function() {props.clear('')}, 1000)
        }
    }, [props.data, props.update_data,props.delete_data, props.import_data, props.add_data, props.edit_data, props.delete_data]);

    useEffect(() => {
        props.import_data && response && props.UploadResp(props.import_data);
    }, [props.import_data]);

    useEffect(() => {
        if(props.data && props.data.data && props.data.data.data){
            InitialArray.map((item,index) => {
                item.type === 1 && (InitialArray[index].display_type = 'Subjective' + ' - ' + item.input_type);
                item.type === 2 && (InitialArray[index].display_type = 'Objective' + ' - ' + item.input_type);
                item.type === 3 && (InitialArray[index].display_type = 'Radio' + ' - ' + item.input_type);
                item.type === 4 && (InitialArray[index].display_type = 'Dropdown' + ' - ' + item.input_type);
                item.type === 5 && (InitialArray[index].display_type = 'Photo' + ' - ' + item.input_type);
                item.type === 6 && (InitialArray[index].display_type = 'WebView');
                item.type === 8 && (InitialArray[index].display_type = 'CSV/EXCEL' + ' - ' + item.input_type);
                item.type === 7 && (InitialArray[index].display_type = 'Checkbox' + ' - ' + item.input_type);
            });
            setQuestions(InitialArray);
        }
    }, [props.update_data, InitialArray, props.delete_data, props.import_data, props.add_data, props.edit_data, props.delete_data]);

    useEffect(() => {
        if(!props.Search){
            setQuestions(InitialArray);
        }
        if(props.Search.length > 2){
            const FilteredArray = InitialArray.filter((post) => {
                const postName = post.title;
                return postName.toLowerCase().includes(props.Search.toLowerCase());
            });
            setQuestions(FilteredArray)
        }
    }, [props.location.clear, props.Search]);

    const deleteQuestion = (e, type, id) => {
        e.preventDefault();
        setModal(type);
        setId(id)
    };

    const handleModal = (e, type, name, id) => {
        e.preventDefault();
        setModal(type);
        setName(name);
        setId(id)
    };

    const CloseModal = (e, type) => {
        e.preventDefault();
        let data;
        if(type === 'enable_yes'){
            data = {
                id: Id,
                status: 0
            };
            props.UpdateQuestionStatus(data);
            props.clear('clear');
        } else{
            setModal(!OpenModal)
        }

        if(type === 'disable_yes'){
            data = {
                id: Id,
                status: 1
            };
            props.UpdateQuestionStatus(data);
            props.clear('clear');
        } else{
            setModal(!OpenModal)
        }

        if(type === 'delete_yes'){
            props.DeleteQuestion(Id);
            setModal(false);
            props.respType({type: 'questions', method: 'delete', response: props.delete_data})
        } else if(type === 'delete_no'){
            setModal(false)
        }
    };

    const changePage = (item) => {
        console.log('QUESTION',item);
        props.history.push({
            pathname: 'questions/edit-questions',
            state: item
        })
    };

    const firstUpdate = useRef(true);
    useLayoutEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
            return;
        }
        props.ImportData(props.fileInfo);
    }, [props.fileInfo]);

    const useSortableData = (items, config = null) => {
        const [sortConfig, setSortConfig] = React.useState(config);
        const sortedItems = React.useMemo(() => {
          let sortableItems = [...items];
          if (sortConfig !== null) {
            sortableItems.sort((a, b) => {
              if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
              }
              if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
              }
              return 0;
            });
          }
          return sortableItems;
        }, [items, sortConfig]);
      
        const requestSort = (key) => {
          let direction = 'ascending';
          if (
            sortConfig &&
            sortConfig.key === key &&
            sortConfig.direction === 'ascending'
          ) {
            direction = 'descending';
          }
          setSortConfig({ key, direction });
        };
      
        return { items: sortedItems, requestSort, sortConfig };
      };
    const { items, requestSort} = useSortableData(questions);

    useEffect(() => {
        props.respType({type: 'Question', method: props.location.method})
    }, [props.location.method]);

    useLayoutEffect(() => {
        setTimeout(() => {
            if(props.location.method && props.location.method === 'add' && props.add_data) {
                props.respType({type: 'questions', method: props.location.method, response: props.add_data})
            }
        }, 1500);
    }, [props.add_data]);

    useLayoutEffect(() => {
        setTimeout(() => {
            if(props.location.method && props.location.method === 'update' && props.edit_data) {
                props.respType({type: 'questions', method: props.location.method, response: props.edit_data})
            }
        }, 1500);
    }, [props.edit_data]);

    useLayoutEffect(() => {
        setTimeout(() => {
            if(props.location.method && props.location.method === 'delete' && props.delete_data) {
                props.respType({type: 'questions', method: props.location.method, response: props.delete_data})
            }
        }, 1500);
    }, [props.delete_data]);

    return (
        <>
        {props.loading && <Loader/>}
        <div className='ml-4 mr-2'>
            <Route exact path={["/dashboard/questions/add-questions", "/dashboard/questions/edit-questions"]} component={FullSidebarQuestions} />
            {props.location.pathname === '/dashboard/questions' && <div className='module-table-wrap w-100 table-responsive'>
                <div className="table-wrap">
                    <table className="table table-bordered m-0">
                        <thead className='text-grey-6'>
                        <tr>
                            <th scope="col" className='dark-background cursor-pointer' onClick={() => requestSort('title')}>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>Title</span>
                                    <img src={Sort} alt="sort" className="ml-2"/>
                                </div>
                            </th>
                            <th scope="col" className='dark-background'>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>Error Text</span>
                                </div>
                            </th>
                            <th scope="col" className='dark-background'>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>Placeholder Text</span>
                                </div>
                            </th>
                            <th scope="col" className='dark-background'>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>MinValidation</span>
                                </div>
                            </th>
                            <th scope="col" className='dark-background'>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>MaxValidation</span>
                                </div>
                            </th>
                            <th scope="col" className='dark-background cursor-pointer' onClick={() => requestSort('display_type')}>
                                <div className="d-flex justify-content-between">
                                    <span className='f-16'>Type</span>
                                    <img src={Sort} alt="sort" className="ml-2"/>
                                </div>
                            </th>
                            <th scope="col" className='dark-background'>
                                <span className='f-16'>Status</span>
                            </th>
                            <th scope="col" className='dark-background'>
                                <span className='f-16'>Action</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody className='light-grey-background'>
                        { items.length > 0 ? items.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>
                                            <span className='text-white pl-2 pr-2'>{item.title}</span>
                                        </td>
                                        <td>
                                            <span className='text-white pl-1'>{item.error_text}</span>
                                        </td>
                                        <td>
                                            <span className='text-white pl-2'>{item.placeholder_text}</span>
                                        </td>
                                        <td>
                                            <span className='text-white pl-2'>{item.min_validation}</span>
                                        </td>
                                        <td>
                                            <span className='text-white pl-2'>{item.max_validation}</span>
                                        </td>
                                        {/* <td>
                                            {item.input_type === 'None' ? <span className='text-white pl-1 pr-3'>{item.input_type}</span>
                                                : <span className='text-white pl-1 pr-3'>
                                                {item.type === 1 && 'Subjective' + ' - ' + item.input_type}
                                                {item.type === 2 && 'Objective' + ' - ' + item.input_type}
                                                {item.type === 3 && 'Radio' + ' - ' + item.input_type}
                                                {item.type === 4 && 'Dropdown' + ' - ' + item.input_type}
                                            </span>}
                                        </td> */}
                                        <td>
                                        <span className='text-white pl-1 pr-3'>{item.display_type}</span>
                                        </td>
                                        <td className='text-center pl-4 pr-4'>
                                            <label className="switch mb-0">
                                                <input
                                                    type="checkbox"
                                                 checked={item.status === 1}
                                                 readOnly
                                                    onClick={(e) => handleModal(e, item.status === 1 ? 'enable' : 'disable', item.title, item.id)}
                                                />
                                                <span className="slider round"/>
                                            </label>
                                        </td>
                                        <td>
                                            <div className="d-flex">
                                                <img onClick={() => changePage(item.id)} src={Pen} alt="pen" className="ml-2 mr-2 cursor-pointer"/>
                                                <img onClick={(e) => deleteQuestion(e, 'delete', item.id)} src={DeleteIcon} alt="Delete" className="ml-2 mr-3 cursor-pointer"/>
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })
                            :
                            <tr>
                                <td colSpan='8' className='text-center border-0'>
                                    <p className='m-0 text-white'>Nothing found</p>
                                </td>
                            </tr>
                        }
                        </tbody>
                    </table>
                    {props.table_loading &&
                            <div className='text-center w-100'>
                                <p className='text-white mt-5 font-weight-bold'>Loading...</p>
                            </div>
                        }
                    <HomeStyle/>
                </div>
            </div>}
            { OpenModal && <Modal Name={Name} Type={OpenModal} Close={(e, type) => CloseModal(e, type)}/> }
        </div>
        </>
    );
}

const mapStateToProps = ({QuestionReducer}) => {
    const { loading, table_loading, data, update_data, delete_data, import_data, add_data, edit_data} = QuestionReducer;
    return { loading, table_loading, data, update_data, delete_data, import_data, add_data, edit_data}
};

const mapDispatchToProps = {
    GetQuestions,
    UpdateQuestionStatus,
    DeleteQuestion,
    ImportData
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Questions));